import { Box, Rating, Stack, Typography } from '@mui/material'
import React from 'react'
import Img from '../../assets/images/bounce.png'
import { BLocation } from '../../types'

interface Props {
  selected?: boolean
  location: BLocation
  onClick: () => void
}

export const ServicerCard = ({ location, selected, onClick }: Props) => {
  return (
    <Stack
      direction='row'
      onClick={onClick}
      sx={{
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #dedede',
        backgroundColor: selected ? 'rgba(27, 161, 250, 0.3)' : 'inherit',
      }}
    >
      <Box
        sx={{
          width: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={Img} alt='boune img' className='bounce-img-card' />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>We fix it phone Repair</Typography>
        <Typography sx={{ fontSize: '12px' }}>{location.address1}</Typography>
        <Typography
          sx={{ fontSize: '12px' }}
        >{`${location.city}, ${location.state} ${location.zip}`}</Typography>
        <Typography sx={{ fontSize: '12px' }}>{location.country}</Typography>
        <Stack direction='row' alignItems='center' alignContent='center' spacing={1}>
          <Typography>4.7</Typography>
          <Rating value={4.7} readOnly />
          <Typography>(90)</Typography>
        </Stack>
      </Box>
    </Stack>
  )
}
